import PropTypes from 'prop-types';

const Bank = ({ color, size, ...props }) => (
    <svg viewBox="0 0 16 16" width={size} height={size} {...props}>
        <path
            d="M3 7.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 3 7.25m5 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 8 7.25m5 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75M7.628.349 1.28 3.975a.95.95 0 0 0 .472 1.775h12.494a.95.95 0 0 0 .47-1.775L8.373.35a.75.75 0 0 0-.744 0M8 1.864l4.176 2.386H3.823zm6 11.386a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5z"
            fill={color}
        />
    </svg>
);

export default Bank;

Bank.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
